export const getInitialState = (key, initialValue) => {
  try {
    const value = window.localStorage.getItem(key) || initialValue;
    window.localStorage.setItem(key, value);
    return value;
  } catch (error) {
    return initialValue;
  }
};